import { z } from '../zod';
import { ObjectIdStringValidationSchema } from '../shared/ObjectId';
import { OrderBumpPageParamsValidationSchema } from './params';
import { orderBumpSettingsInputFields } from './settings';

const createOrderBumpBodyShape = {
  productId: ObjectIdStringValidationSchema.meta({
    description:
      'ID of a product with `role: orderbump` (create one with create_product, find one with list_products). It must share the page currency, have one enabled price that is not a payment plan, and not already be sold or offered on this page.',
  }),
  ...orderBumpSettingsInputFields,
};

export const CreateOrderBumpRequestValidationSchema = z
  .object(createOrderBumpBodyShape)
  .strict()
  .meta({ id: 'CreateOrderBumpRequest' });

export const CreateOrderBumpInputValidationSchema =
  OrderBumpPageParamsValidationSchema.extend(createOrderBumpBodyShape);

export type CreateOrderBumpInput = z.infer<typeof CreateOrderBumpInputValidationSchema>;
